import { get, post, put, deleteRequest, publicGet, publicPost, publicPostFd } from "../helpers/apihelpers";

// ── Public (no login) ───────────────────────────────────────────────────

export const LookupStudentService = async (mobile) => {
    try {
        const result = await publicPost(`api/teacher_feedback/lookup_student`, { mobile });
        return result;
    } catch (err) {
        return err.response;
    }
}

export const PublicTeacherListService = async (student = '') => {
    try {
        const result = await publicGet(`api/teacher_feedback/teachers${student ? `?student=${student}` : ''}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CheckFeedbackStatusService = async (student, teacher) => {
    try {
        const result = await publicGet(`api/teacher_feedback/status?student=${student}&teacher=${teacher}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const SubmitFeedbackService = async (formData) => {
    try {
        const result = await publicPostFd(`api/teacher_feedback/submit`, formData);
        return result;
    } catch (err) {
        return err.response;
    }
}

// ── Teacher panel ───────────────────────────────────────────────────────

export const TeacherFeedbackLeaderboardService = async (month = '') => {
    try {
        const result = await get(`api/teacher_feedback/leaderboard${month ? `?month=${month}` : ''}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const MyTeacherPerformanceService = async (month = '', teacher = '') => {
    try {
        const params = new URLSearchParams();
        if (month) params.set('month', month);
        if (teacher) params.set('teacher', teacher);
        const qs = params.toString();
        const result = await get(`api/teacher_feedback/my_performance${qs ? `?${qs}` : ''}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DownloadTeacherPerformanceReportService = async (month = '', teacher = '') => {
    try {
        const params = new URLSearchParams();
        if (month) params.set('month', month);
        if (teacher) params.set('teacher', teacher);
        const qs = params.toString();
        const result = await get(`api/teacher_feedback/download_report${qs ? `?${qs}` : ''}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

// ── Admin ───────────────────────────────────────────────────────────────

export const AdminTeacherFeedbackListService = async (page = 1, month = '', teacher = '', text = '') => {
    try {
        const result = await get(`api/teacher_feedback/admin/list?page=${page}&month=${month}&teacher=${teacher}&text=${text}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const AdminUpdateTeacherFeedbackService = async (id, data) => {
    try {
        const result = await put(`api/teacher_feedback/admin/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

// Soft-excludes/restores one feedback entry from the leaderboard/rank/average
// rating/category-breakdown aggregates without deleting it.
export const ExcludeTeacherFeedbackService = async (id, reason = '') => {
    try {
        const result = await put(`api/teacher_feedback/admin/exclude/${id}`, { reason });
        return result;
    } catch (err) {
        return err.response;
    }
}

export const RestoreTeacherFeedbackService = async (id) => {
    try {
        const result = await put(`api/teacher_feedback/admin/restore/${id}`, {});
        return result;
    } catch (err) {
        return err.response;
    }
}

// Same as above but for every entry one parent has submitted — month is
// optional: pass it to scope to just that month, omit it for all of them.
export const ExcludeStudentFeedbackService = async (student, month = '', reason = '') => {
    try {
        const result = await put(`api/teacher_feedback/admin/exclude_student`, { student, month, reason });
        return result;
    } catch (err) {
        return err.response;
    }
}

export const RestoreStudentFeedbackService = async (student, month = '') => {
    try {
        const result = await put(`api/teacher_feedback/admin/restore_student`, { student, month });
        return result;
    } catch (err) {
        return err.response;
    }
}

export const AdminSubmissionStatusService = async (teacher, month = '', page = 1, text = '') => {
    try {
        const result = await get(`api/teacher_feedback/admin/submission_status?teacher=${teacher}&month=${month}&page=${page}&text=${text}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

// ── Incentive ledger (admin adds/edits +/- adjustments; total is always the
// live sum, so editing an entry immediately changes the total) ────────────

export const ListIncentiveService = async (teacher, month = '') => {
    try {
        const result = await get(`api/teacher_feedback/admin/incentive?teacher=${teacher}&month=${month}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const AddIncentiveService = async (teacher, month, amount, remarks = '') => {
    try {
        const result = await post(`api/teacher_feedback/admin/incentive`, { teacher, month, amount, remarks });
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateIncentiveService = async (id, data) => {
    try {
        const result = await put(`api/teacher_feedback/admin/incentive/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteIncentiveService = async (id) => {
    try {
        const result = await deleteRequest(`api/teacher_feedback/admin/incentive/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}
